import type { RefObject } from "react";
import { useEffect, useRef, useState } from "react";

type UseRevealOnScrollResult<T extends Element> = {
  ref: RefObject<T | null>
  isVisible: boolean
};

export function useRevealOnScroll<T extends Element = HTMLDivElement>(
  threshold = 0.15,
): UseRevealOnScrollResult<T> {
  const ref = useRef<T>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, isVisible };
}
